import React, { createContext, useContext, ReactNode } from 'react';
import { useTranslation as useI18nTranslation } from 'react-i18next';

interface TranslationContextType {
  t: (key: string, options?: any) => string;
  language: string;
  setLanguage: (lang: string) => void;
}

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const TranslationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { t, i18n } = useI18nTranslation();

  const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <TranslationContext.Provider value={{ t, language: i18n.language, setLanguage }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = (namespace?: string | string[]) => {
  const context = useContext(TranslationContext);
  const { t: i18nT, i18n } = useI18nTranslation(namespace);
  
  if (!context) {
    // Context yoksa direkt i18next kullan
    return {
      t: i18nT,
      language: i18n.language,
      setLanguage: (lang: string) => i18n.changeLanguage(lang)
    };
  }
  
  return {
    t: i18nT,
    language: context.language,
    setLanguage: context.setLanguage
  };
};
